import type { Step } from 'react-joyride';

export const campaignsListTourSteps: Step[] = [
  {
    target: '#myProductSelect',
    content: 'Selecione o produto que deseja consultar / criar links',
  },
];
export const campaignsButtonsTourSteps: Step[] = [
  {
    target: '#myCheckoutBooster',
    content: 'Deixe o carregamento do seu checkout instantêneo com essa funcionalidade',
  },
  {
    target: '#myUrlCreator',
    content: 'Receba eventos do nosso sistema na url cadastrada',
  },
  {
    target: '#myNewCampaign',
    content: 'Crie suas campanhas aqui',
  },
  {
    target: '#trackCampaignButton',
    content: 'Adicione seus pixels de rastreamento',
  },
];
